import { useEffect, useRef } from 'react';
import BreadCrumb from '../../../component/BreadCrumb';
import TabBox from '../../../component/TabBox';
import SemesterEnrolmentStatusViewTab1Body from './SemesterEnrolmentStatusViewTab1Body';
import SemesterEnrolmentStatusViewTab2Body from './SemesterEnrolmentStatusViewTab2Body';
import { VIEW_SEMESTER_ENROLMENT_STATUS } from './../../../constant/ViewConstant';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';

const SemesterEnrolmentStatusView = () => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });

    const tab = useRef(null);

    useEffect(() => {
        var defaultTabNo = NullCheckUtil.isNotNull(queryData.tabNo) ? queryData.tabNo : 1;
        tab.current.initTab(
            [
                {
                    tabNo: 1,
                    title: '학점교류 학생목록',
                    element: <SemesterEnrolmentStatusViewTab1Body key={1} tabNo={1} />,
                },
                {
                    tabNo: 2,
                    title: '학점교류 신청허가',
                    element: <SemesterEnrolmentStatusViewTab2Body key={2} tabNo={2} />,
                },
            ],
            defaultTabNo,
        );
    }, []);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg03'>
                    <h2 className='con-title'>{VIEW_SEMESTER_ENROLMENT_STATUS.title}</h2>
                    <p className='con-title-p'>{VIEW_SEMESTER_ENROLMENT_STATUS.subTitle}</p>
                </div>
                <div className='sub-nav-wrap h-44'>
                    <div className='sub-nav-box'>
                        <BreadCrumb />
                    </div>
                </div>
                <TabBox ref={tab} />
            </div>
        </section>
    );
};

export default SemesterEnrolmentStatusView;
